export default {
  getShopTime: (state) => state.shopTime,
};
